import Disclosure from "../utils/Disclosure.js";

class SiteHeader {
    constructor(element) {
        this.el = element;

        this.init();
    }

    init() {
        this.setupSearchForm();
    }

    setupSearchForm() {
        const searchForm = document.querySelector(".site-header__search");

        if (!searchForm) {
            return;
        }

        if (window.matchMedia("(min-width: 820px)").matches) {

            new Disclosure(searchForm, {
                collapseOnEscape: true,
                collapseOnFocusout: true,
                focusWithinOnExpand: true,
                setHiddenAttribute: false,
            });

        }
        
    }

}

document.addEventListener("DOMContentLoaded", () => {
    const element = document.querySelector(".site-header");

    if (element) {
        new SiteHeader(element);
    }
});
